// Utils
import { isLocalId } from '../IdMap';

// Références d'un élément vers des entités créées sur l'appareil (tags, essences) : dépendances dans la file, ids serveur à l'envoi
export const getElementRefs = (feature) => [
    ...(feature?.properties?.tagId || []).map(id => ({ entity: 'tag', id })),
    ...(feature?.properties?.essenceId < 0 ? [{ entity: 'essence', id: feature.properties.essenceId }] : [])
];

// Tag créé sur l'appareil : id du tag existant sous le même libellé ; retiré si sa création a échoué ou a été abandonnée
const resolveTagIds = async (tagIds, context) => {
    const resolved = [];
    for (const id of tagIds) {
        const serverId = await context.idMap.resolve('tag', id);
        if (serverId === false || (await context.outbox?.hasPendingFor(`tag:${id}`))) continue;
        resolved.push(serverId);
    }
    return resolved;
};

// Ids temporaires des observations, dans l'ordre d'envoi (null pour une observation déjà connue du serveur)
export const getLocalObservationIds = (feature) => (feature?.properties?.observations || []).map(observation => isLocalId('observation', observation.id) ? observation.id : null);

// Observation créée sur l'appareil : id serveur s'il a déjà été attribué par un envoi précédent, sinon sans id (l'API la crée)
export const resolveElementRefs = async (feature, context) => {
    if (!feature?.properties || !context?.idMap) return feature;
    const properties = { ...feature.properties };
    if (properties.tagId?.length) properties.tagId = await resolveTagIds(properties.tagId, context);
    // Essence créée sur l'appareil (id négatif) : l'élément attend sa création, l'id serveur est alors connu
    if (properties.essenceId < 0) properties.essenceId = (await context.idMap.resolve('essence', properties.essenceId)) ?? properties.essenceId;
    if (properties.observations?.some(observation => isLocalId('observation', observation.id)))
        properties.observations = await Promise.all(properties.observations.map(async ({ id, ...observation }) => {
            if (!isLocalId('observation', id)) return { id, ...observation };
            const serverId = await context.idMap.get('observation', id);
            return serverId ? { id: serverId, ...observation } : observation;
        }));
    return { ...feature, properties };
};

// L'API renvoie les observations dans l'ordre reçu : ids serveur notés pour les envois suivants
export const rememberObservationIds = async (localIds, serverFeature, context) => {
    const serverObservations = serverFeature?.properties?.observations || [];
    for (const [index, localId] of (localIds || []).entries())
        if (localId && serverObservations[index]?.id) await context.idMap?.set('observation', localId, serverObservations[index].id);
};
